<div *ngIf="isLoading">Loading Introducer List...</div>

<select *ngIf="!isLoading" (change)="optionChanged.emit(true)" [compareWith]="byId" class="form-control"
        name="introducer" [(ngModel)]="model.introducer" [required]="required">
  <option *ngFor="let singleIntroducer of introducers" [ngValue]="singleIntroducer">{{ singleIntroducer.name }}</option>
</select>
